import gql from 'graphql-tag'

export function buildContractQuery (fields) {
    return gql`
        query contract(
            $id: ID!
        ) {
            contract(
                id: $id
            ) {
                ${fields}
            }
        }
    `
}

const defaultContractQueryFields = `
    id
    contractNumbers {
        id
        number
    }
    status
    customer {
        id
        contactNumber {
            id
            number
        }
        status
        mainAddress {
            id
            label {
                id
                label
            }
            po_box
            address1
            address2
            address3
            zip
            city
        }
        emailAddresses {
            id
        }
        ... on Person {
            first_name
            last_name
            gender
            personal_pronoun
            title
        }
        ... on Company {
            company_name
        }
        consultants {
            id
        }
    }
    consultant {
        id
        contact_number
        first_name
        last_name
        gender
        title
        consultingCompany {
            id
        }
        consulting_company_name
        consulting_settings_status
    }
    currentContractInformation {
        product {
            id
            name
            basicProvider {
                id
                name
                display_name
            }
            currentInsurerConfigurationSet {
                id
                configurations {
                    id
                    insurer {
                        id
                        name
                        display_name
                    }
                }
            }
            template {
                version
                form_configuration
                template_configuration
            }
        }
        productTemplate {
            name
            category {
                key
                name
            }
            subCategory {
                key
                name
            }
            version
            form_configuration
            template_configuration
        }
        product_field_values
        start_date
        end_date
        premium
        generalAgency {
            id
            company_name
        }
        managed_by_status
        consulting_mandate_enquiry_send_date
    }
     currentChangeApplication {
        id
        number {
            number
        }
        external_reference_number
    }
    cancellations {
        id
        status
        cancellation_date
    }
    termination_date
    pinnedComments {
        id
        creator {
            id
            contact_number
            first_name
            last_name
            gender
            title
            consultingCompany {
                id
            }
        consulting_company_name
        }

        text
        pinned

        created_at
        updated_at
    }
    replacedBy {
        id
    }
    number_of_contract_files
    number_of_comments
    commissionSplits {
        id
        additionalRecipient {
            id
            first_name
            last_name
            consultingCompany {
                id
                company_name
            }
        }
        split_rate
        active_from
        active_until
        is_active
    }
    has_active_commission_splits
    commissionRecipientOverride {
        id
        first_name
        last_name
        contact_number
        gender
        title
        consultingCompany {
            id
        }
        consulting_company_name
    }
    has_commission_recipient_override
    created_at
    updated_at
`

export const targetObjectContractQueryFields = `
    id
    contractNumbers {
        id
        number
    }
    status
    customer {
        id
        status
        consultingSettings {
            status
            company {
                id
                company_name
            }
        }
        productProviderSettings {
            status
            display_name
        }
        contactNumber {
            id
            number
        }
        addresses {
            id
            category {
                id
                key
                name
            }
            label {
                id
                key
                label
            }
            po_box
            address1
            address2
            address3
            zip
            city
            country {
                id
                name
            }
            valid_from
            valid_until
            is_main_correspondence_address
            status
        }
        mainAddress {
            id
            category {
                id
                key
                name
            }
            label {
                id
                key
                label
            }
            po_box
            address1
            address2
            address3
            zip
            city
            country {
                id
                name
            }
            valid_from
            valid_until
            is_main_correspondence_address
            status
        }
        emailAddresses {
            id
            category {
                id
                key
                name
            }
            label {
                id
                key
                label
            }
            email
            is_main_email_address
        }
        mainEmailAddress {
            id
            category {
                id
                key
                name
            }
            label {
                id
                key
                label
            }
            email
            is_main_email_address
        }
        consultants {
            id
            contact_number
            first_name
            last_name
            gender
            title
            consultingCompany {
                id
            }
            consulting_company_name
            consulting_settings_status
        }
        ... on Person {
            first_name
            last_name
            gender
            personal_pronoun
        }
        ... on Company {
            company_name
            is_tenant_company
        }
    }
    consultant {
        id
        contact_number
        first_name
        last_name
        gender
        title
        consultingCompany {
            id
        }
        consulting_company_name
        consulting_settings_status
    }
    currentContractInformation {
        product {
            name
            basicProvider {
                id
                name
                display_name
            }
            currentInsurerConfigurationSet {
                id
                configurations {
                    id
                    insurer {
                        id
                        name
                        display_name
                    }
                }
            }
        }
        productTemplate {
            name
            category {
                name
            }
            subCategory {
                name
            }
            version
        }
        start_date
        end_date
        premium
    }
    cancellations {
        id
        status
        cancellation_date
    }
    termination_date
    replacedBy {
        id
    }
`

export const CONTRACT_QUERY = buildContractQuery(defaultContractQueryFields)
